import axios from 'axios';
import defaultRequestOptions from './defaultRequestOptions';

async function generateOtp(apiUrl) {
  const res = await axios.post(`${apiUrl}/otp/generate`, {}, defaultRequestOptions());
  return res.data;
}

async function verifyOtp(apiUrl, otp) {
  const res = await axios.post(`${apiUrl}/otp/verify`, { otp }, { ...defaultRequestOptions(), params: { hideSpinner: true } });
  return res.data;
}

async function resendOtp(apiUrl) {
  const res = await axios.post(`${apiUrl}/otp/resend`, {}, { ...defaultRequestOptions(), params: { hideSpinner: true } });
  return res.data;
}

export default {
  generateOtp,
  verifyOtp,
  resendOtp,
};
